import { render, staticRenderFns } from "./NrpTag.vue?vue&type=template&id=0e835c93&scoped=true"
import script from "./NrpTag.vue?vue&type=script&lang=js"
export * from "./NrpTag.vue?vue&type=script&lang=js"
import style0 from "./NrpTag.vue?vue&type=style&index=0&id=0e835c93&prod&lang=less&scoped=true"
import style1 from "./NrpTag.vue?vue&type=style&index=1&id=0e835c93&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e835c93",
  null
  
)

export default component.exports